import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "../../Component/datePicker";
import PageTitle from "../../Module/pageTitle";
import { upcomingInterview, updateUpcomingInterviewStatus } from "../../Action/interviewAction";
import LabelField from "../../Component/labelField";
import SubmitButton from "../../Component/SubmitButton";
import { getExamListNew, getParentCourseNew } from "../../Action/courseAction";
import { getSubExam } from "../../Action/adminPanelAction";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from "@mui/material/Tooltip";
import { showErrorSnackbar, showSuccessSnackbar } from "../../Action/snackbarAction";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import Dropdown from "../../Component/dropdown";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
import { validEndDate } from "../../Utils/errorMsg";
function UpcomingInterview() {
  const dispatch = useDispatch();
  const [examName, setExamName] = useState("");
  const [examList, setExamList] = useState([]);
  const [subExamName, setSubExamName] = useState("");
  const [subExamList, setSubExamList] = useState([]);
  const [examStream, setExamStream] = useState("");
  const [examStreamList, setExamStreamList] = useState([]);
  const [upcomingInterviewList, setUpcomingInterviewList] = useState([]);
  const [pastInterviewList, setPastInterviewList] = useState([]);
  const [startDate, setStartDate] = useState(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );

  const fetchAvailability = useCallback(() => {
    const payload = {
      startDate: startDate,
      endDate: endDate,
    };
    if (examName) {
      payload.examTypeId = examName?._id
    }
    if (subExamName) {
      payload.subExamTypeId = subExamName?._id
    }
    if (examStream) {
      payload.baseCourseId = examStream?._id
    }

    dispatch(
      upcomingInterview(payload, (res) => {
        const now = moment();

        const formatted = (res?.data || []).map((item) => {
          const datePart = moment(item.interviewDate).local().format("YYYY-MM-DD");

          const fullDateTime = moment(
            `${datePart} ${item.interviewTime}`,
            "YYYY-MM-DD hh:mm A"
          );
          return {
            ...item,
            fullDateTime,
          };
        });
        // 🔥 Only Upcoming
        const upcomingOnly = formatted
          .filter((item) => item.fullDateTime.isSameOrAfter(now))
          .sort((a, b) => a.fullDateTime.valueOf() - b.fullDateTime.valueOf());

        setUpcomingInterviewList(upcomingOnly);

        const pastOnly = formatted
          .filter((item) => item.fullDateTime.isBefore(now))
          .sort((a, b) => b.fullDateTime.valueOf() - a.fullDateTime.valueOf());

        setPastInterviewList(pastOnly);
        // setUpcomingInterviewList(res?.data || []);
      })
    );
  }, [dispatch, startDate, endDate, examName, subExamName, examStream]);
  console.log("upcomingInterviewList", upcomingInterviewList);
  console.log("pastInterviewList", pastInterviewList);
  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res || [])
      })
    );
    fetchAvailability();
  }, [])
  const onChangeExams = (val) => {
    setExamName(val)
    setSubExamName("");
    setExamStream("");
    setExamStreamList([])
    setSubExamList([])
    if (!val) return;
    dispatch(
      getSubExam({ examTypeId: val?._id }, (res) => {
        if (res?.data?.length > 0) setSubExamList(res?.data);
        else {
          dispatch(
            getParentCourseNew(`${val?._id}`, (res) => {
              setExamStreamList(res || [])
            })
          );
        }
      })
    );
  };

  const onChangeSubExam = (value) => {
    setSubExamName(value);
    setExamStreamList([])
    dispatch(
      getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
        setExamStreamList(res || [])
      })
    );
  };
  const onChangeExamStream = (val) => {
    setExamStream(val)
  }

  const onSubmitData = (e) => {
    e.preventDefault();
    fetchAvailability();
  };

  const validations = () => {
    return (
      startDate === "" || endDate === ""
    );
  };
  const [cancelPopupOpen, setCancelPopupOpen] = useState(false);
  const [interviewData, setInterviewData] = useState({});
  const setUpcomingStatus = (id, status) => {
    if (status === "completed") {
      const postData = {
        interviewStatus: status
      };
      dispatch(
        updateUpcomingInterviewStatus(postData, id, (res) => {
          console.log("status updated", res)
          fetchAvailability();
        })
      );
    } else if (status === "cancelled") {
      setInterviewData({
        interviewStatus: status,
        interviewId: id
      })
      setCancelPopupOpen(true);
    }
  };

  const handleCancelInterview = () => {
    const postData = {
      interviewStatus: interviewData?.interviewStatus,
      comment: interviewData?.reason
    };
    dispatch(
      updateUpcomingInterviewStatus(postData, interviewData?.interviewId, (res) => {
        console.log("status updated", res)
        setCancelPopupOpen(false);
        fetchAvailability();
      })
    );
  }
  const handleClose = () => {
    setCancelPopupOpen(false);
    setInterviewData({});
  }
const [showPast, setShowPast] = useState(false);
  return (
    <div className="contentBox">
      <div className={`contentBox`}>
        <PageTitle
          name="Upcoming Interview"
        />
      </div>

      <div className="row m-0">
        <div className="formDiv blank-20px">
          <div className="mt-4">
            <div className="mt-3">
              <form onSubmit={onSubmitData}>
                <div className="d-flex flex-wrap">
                  <div className="d-flex mb-2 align-items-center  col-4 pe-4">
                    <LabelField labelName={"Start Date :"} />
                    <DatePicker
                      setInputText={(value) => {
                        if (value > endDate && endDate) {
                          dispatch(showErrorSnackbar(validEndDate));
                          return;
                        }
                        setStartDate(value);
                      }}
                      value={startDate}
                    />
                  </div>
                  <div className="d-flex mb-2 align-items-center col-4 pe-4">
                    <LabelField labelName={"End Date :"} />
                    <DatePicker
                      setInputText={(value) => {
                        if (value < startDate && startDate) {
                          dispatch(showErrorSnackbar(validEndDate));
                          return;
                        }
                        setEndDate(value);
                      }}
                      value={endDate}
                    />
                  </div>
                  <div className="col d-flex align-items-center">
                    <LabelField labelName={"Exam Name"} />
                    <Dropdown
                      setInputText={(value) => onChangeExams(value)}
                      value={examName}
                      options={examList}
                      labelName="Select Exam Name"
                    />
                  </div>

                  {subExamList?.length > 0 ? (
                    <div className="d-flex align-items-center mb-2 col-4 pe-4">
                      <LabelField
                        labelName={"Sub Exam Name:"}
                        isRequired={true}
                      />
                      <Dropdown
                        setInputText={(value) => onChangeSubExam(value)}
                        value={subExamName}
                        options={subExamList}
                        labelName="Select Sub Exam Name"
                      />
                    </div>
                  ) : null}
                  <div className="col-4 d-flex justify-content-center align-items-center">
                    <LabelField labelName={"Exam Stream"} />
                    <Dropdown
                      labelName="Select Exam Stream"
                      setInputText={(value) => onChangeExamStream(value)}
                      value={examStream}
                      options={examStreamList}
                    />
                  </div>
                  <div className="col-4 ms-3">
                    <SubmitButton name="Search" validations={validations()} />
                  </div>
                </div>
              </form>
              <div className="mb-2">
                <button className={`btn ${showPast?'btn-primary':'btn-outline-primary'}`} onClick={() => setShowPast(true)}>Past</button>
                <button className={`btn ms-2 ${!showPast?'btn-primary':'btn-outline-primary'}`} onClick={() => setShowPast(false)}>Upcoming</button>
              </div>
              <table className="w-100">
                <thead className="text-center">
                  <tr>
                    <th>
                      <label>S.R</label>
                    </th>
                    <th>
                      <label>Date</label>
                    </th>
                    <th>
                      <label>Student Name</label>
                    </th>
                    <th>
                      <label>Category</label>
                    </th>
                    {/* <th>
                      <label>Exam</label>
                    </th> */}
                    <th>
                      <label>Subject</label>
                    </th>
                    <th>
                      <label>Qualify For</label>
                    </th>
                    <th>
                      <label>Rank</label>
                    </th>
                    
                    <th>
                      <label>Mobile No</label>
                    </th>
                    
                    <th>
                      <label>Slot</label>
                    </th>
                    <th>
                      <label>url</label>
                    </th>
                    <th>
                      <label>Status</label>
                    </th>
                    <th>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {(showPast ? pastInterviewList : upcomingInterviewList)?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                         <td>{moment.utc(item.interviewDate).format("DD-MM-YYYY")}</td>
                        <td className="text-start">{item?.firstName} {item?.lastName}</td>
                         <td>{item?.catagory?.name || "-"}</td>
                        {/* <td>{item?.examTypeId?.name}</td> */}
                        <td className="text-start">{item?.baseCourseId?.name}</td>
                        <td>{item?.qualifyFor || "-"}</td>
                        <td>{item?.rank || "-"}</td>
                        <td>
                          {item?.mobileNo
                            ? String(item?.mobileNo).replace(
                              /^(\d{2})\d+(\d{2})$/,
                              "$1******$2",
                            )
                            : "-"}
                          {item?.mobileNo && (
                            <span
                              className="cursor ms-1"
                              onClick={() => {
                                navigator.clipboard.writeText(item?.mobileNo);
                                dispatch(showSuccessSnackbar("Number copied!"));
                              }}
                            >
                              <ContentCopyRoundedIcon
                                color="primary"
                                fontSize="small"
                              />
                            </span>
                          )}
                        </td>
                       
                        <td>{item?.interviewTime}</td>
                        <td><a href={item?.meetingUrl} target="_blank" rel="noreferrer">{item?.meetingUrl}</a></td>
                        <td>{item?.interviewStatus}</td>
                        <td>{item?.interviewStatus === "booked" ?
                          <div>
                            <Tooltip title="Completed" arrow
                              placement="top">
                              <CheckCircleIcon
                                color="success"
                                className="cursor"
                                onClick={() => {
                                  setUpcomingStatus(item?._id, "completed")
                                }}
                              />
                            </Tooltip>

                            <Tooltip title="Cancelled" arrow
                              placement="top">
                              <CancelIcon
                                color="error"
                                className="cursor ms-2" onClick={() => {
                                  setUpcomingStatus(item?._id, "cancelled")
                                }}
                              />
                            </Tooltip>
                          </div> : "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={cancelPopupOpen} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Cancel Interview</DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <textarea
                className="form-control col-md-12"
                value={interviewData?.reason || ""}
                onChange={(e) => setInterviewData({ ...interviewData, reason: e.target.value })}
                placeholder="Enter reason for cancellation"
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>

          <Button
            onClick={handleCancelInterview}
            variant="contained"
            disabled={!interviewData?.reason}
          >
            submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default UpcomingInterview;
